import { Component, OnInit, computed, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { DomainAllowlistFacade } from '../facade/domain-allowlist.facade';
import { IDomainAllowlist, IPatchDomainAllowlist, IPostDomainAllowlist } from '../models/domain-allowlist';

@Component({
  selector: 'app-domain-allowlist',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, FontAwesomeModule],
  templateUrl: './domain-allowlist.html',
})
export class DomainAllowlistComponent implements OnInit {
  private fb = inject(FormBuilder);
  private facade = inject(DomainAllowlistFacade);

  createForm!: FormGroup;
  editForm!: FormGroup;
  editingId: number | null = null;
  isSubmitting = false;

  items = computed(() => (this.facade.itemsSignal() || []).slice().sort((a, b) => a.domain.localeCompare(b.domain)));

  ngOnInit(): void {
    this.createForm = this.fb.group({
      domain: ['', [Validators.required, Validators.pattern(/^(?!-)(?:[a-zA-Z0-9-]{1,63}\.)+[a-zA-Z]{2,}$/)]],
      description: [''],
    });

    this.editForm = this.fb.group({
      domain: ['', [Validators.required, Validators.pattern(/^(?!-)(?:[a-zA-Z0-9-]{1,63}\.)+[a-zA-Z]{2,}$/)]],
      description: [''],
    });

    this.facade.getDomainAllowlist();
  }

  submitCreate(): void {
    if (this.createForm.invalid) return;
    this.isSubmitting = true;
    const payload: IPostDomainAllowlist = this.createForm.value;
    this.facade.postDomainAllowlist(payload);
    this.createForm.reset();
    this.isSubmitting = false;
  }

  beginEdit(item: IDomainAllowlist) {
    this.editingId = item.id;
    this.editForm.patchValue({ domain: item.domain, description: item.description || '' });
  }

  saveEdit() {
    if (this.editForm.invalid || this.editingId == null) return;
    const changes: IPatchDomainAllowlist = this.editForm.value;
    this.facade.patchDomainAllowlist(this.editingId, changes);
    this.editingId = null;
    this.editForm.reset();
  }

  cancelEdit() {
    this.editingId = null;
    this.editForm.reset();
  }

  delete(id: number) {
    this.facade.deleteDomainAllowlist(id);
  }

  trackById(_: number, item: IDomainAllowlist) {
    return item.id;
  }
}
